import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

const ADMIN_EMAIL = "ray@groomsy.io";

export default function AdminRoute({ children }) {
  const { user } = useUser();

  if (user === undefined) return null; // Loading state

  if (!user) return <Navigate to="/login" replace />;

  const isAdmin = !!user?.email && user.email.toLowerCase() === ADMIN_EMAIL;

  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return children;
}
